import { render, staticRenderFns } from "./ModalAccountSuspended.vue?vue&type=template&id=2deb8e5c&scoped=true&"
import script from "./ModalAccountSuspended.vue?vue&type=script&lang=js&"
export * from "./ModalAccountSuspended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deb8e5c",
  null
  
)

export default component.exports